import {
  PhBookOpen,
  PhCalendarBlank,
  PhConfetti,
  PhCreditCard,
  PhCrown,
  PhCurrencyCircleDollar,
  PhDesktop,
  PhForkKnife,
  PhGift,
  PhInfo,
  PhMoney,
  PhNewspaper,
  PhNotepad,
  PhPaperPlaneTilt,
  PhPhone,
  PhPizza,
} from 'phosphor-vue/dist/phosphor-vue.esm'

export const announcementIcons = [
  {
    icon: PhInfo,
    key: 'Info',
  },
  {
    icon: PhConfetti,
    key: 'Confetti',
  },
  {
    icon: PhPizza,
    key: 'Pizza',
  },
  {
    icon: PhForkKnife,
    key: 'ForkKnife',
  },
  {
    icon: PhGift,
    key: 'Gift',
  },
  {
    icon: PhCreditCard,
    key: 'CreditCard',
  },
  {
    icon: PhMoney,
    key: 'Money',
  },
  {
    icon: PhCurrencyCircleDollar,
    key: 'CurrencyCircleDollar',
  },
  {
    icon: PhCalendarBlank,
    key: 'CalendarBlank',
  },
  {
    icon: PhBookOpen,
    key: 'BookOpen',
  },
  {
    icon: PhPhone,
    key: 'Phone',
  },
  {
    icon: PhCrown,
    key: 'Crown',
  },
  {
    icon: PhDesktop,
    key: 'Desktop',
  },
  {
    icon: PhPaperPlaneTilt,
    key: 'PaperPlaneTilt',
  },
  {
    icon: PhNotepad,
    key: 'Notepad',
  },
  {
    icon: PhNewspaper,
    key: 'Newspaper',
  },
]
